import { networkStatusTypes } from '@/domain/enums/networkStatus';
import translate from '@/services/translate';

const networkStatusOptions = () => [
  {
    id: networkStatusTypes.ACTIVE,
    name: translate('network-status.status.active'),
  },
  {
    id: networkStatusTypes.INACTIVE,
    name: translate('network-status.status.inactive'),
  },
  {
    id: networkStatusTypes.UNDETERMINED,
    name: translate('network-status.status.undetermined'),
  },
];

export default networkStatusOptions;
